export enum NewsType {
  Covering = "پوششی",
  Production = "تولیدی",
  Sending = "ارسالی",
  Recieving = "دریافتی",
  Quoting = "نقلی",
}
